import _ from 'lodash'
import '../../../css/svdreact.css'
import '../../../css/dream.css'
import '../../../css/ca.css'
import '../../../css/cm.css'
import Terrain from '../../terrain/Terrain'
import CardTerrain from '../../terrain/CardTerrain'
import TerrainGallery from '../../terrain/TerrainGallery'
import {  Button as SVAButton } from 'antd';

import GlassTerrain from '../../terrain/GlassTerrain'
import { noop } from 'react-bootstrap-typeahead/types/utils'
const React = require('react')
class GreatTerrainContainer extends React.Component {
  
    constructor(props) {
        super(props)
        let me = this
        
        this.getGgChildContainers = this.getGgChildContainers.bind(me)
       // this.getChildContainersR1 = this.getChildContainersR1.bind(me)
        this.getGgBody = this.getGgBody.bind(me)
       // this.getCgBodyR1 = this.getCgBodyR1.bind(me)
    }

    getGgChildContainers(){
     
        return(

            <div id="gfeatures"  className="gfeatures section">
            
            <div className="col-lg-12">
          <div className="gfeatures-content">
            <div className="row">
              <div className="col-lg-3">
                <div className="gfeatures-item first-feature wow fadeInUp animated great-anim" data-wow-duration="1s" data-wow-delay="0s" >
                  <div className="first-number number">
                    <h6>01</h6>
                  </div>
                  <div className="icon"></div>
                  <h4>Holiday Travels</h4>
                  <div className="line-dec"></div>
                  <p>Leisure Travel is our expertise plus access to special negotiated fares at 10-38% off. Exclusive itineraries + smart travel hacks = travel deals, no hidden fees, just great deals. Trusted for years in Unites States with over  reviews.</p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="gfeatures-item second-feature wow fadeInUp animated great-anim-2" data-wow-duration="1s" data-wow-delay="0.2s" >
                  <div className="second-number number">
                    <h6>02</h6>
                  </div>
                  <div className="icon"></div>
                  <h4>Work In Action</h4>
                  <div className="line-dec"></div>
                  <p>Share Your Details – Call or email us your travel dates and preferences. We Search for You – Our experts find the best deals and send 2–3 top options via email. Pick & Pay – Choose your fare or customize, then pay securely via link.</p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="gfeatures-item first-feature wow fadeInUp animated  great-anim-4" data-wow-duration="1s" data-wow-delay="0.4s" >
                  <div className="third-number number">
                    <h6>03</h6>
                  </div>
                  <div className="icon"></div>
                  <h4>Book Flights</h4>
                  <div className="line-dec"></div>
                  <p>Search and Book Flights Enjoy no date change fee and more change flexibility than online platforms. Get 24/7 support from team for rescheduling, plan changes, or emergencies—at loweest service fees.</p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="gfeatures-item second-feature last-gfeatures-item wow fadeInUp animated great-anim-6" data-wow-duration="1s" data-wow-delay="0.6s" >
                  <div className="fourth-number number">
                    <h6>04</h6>
                  </div>
                  <div className="icon"></div>
                  <h4>Travel Advisors</h4>
                  <div className="line-dec"></div>
                  <p>With Our Travel Platform  , our expert books the perfect flight at the best price and takes care of everything—seats, meals, insurance, and miles—saving you time and money.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
           
          </div>
        )

    }
    getGgBody(){
      const lastestUpdateDate = 'Data Refresh Daily'
      return this.getGgChildContainers()    
    }

    render(){

        console.log('svrender', this.props)
       const {my_data} = this.props

          return (
            <noop>
            
           
             <div className="col-md-12">
             {
                 this.getGgBody(my_data)
             }
              
             
            </div>
         </noop>
        )

    }
}

export default GreatTerrainContainer